import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(about)/about/components/buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.7_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.56.0_babel-p_99e21a6d23601107dfb29e25e5cfb6c0/node_modules/next/dist/client/app-dir/link.js");
